import { customFieldsPayload } from "components/BaseForm";
import { getInvoicesTotalValue } from "components/helpers";
import { toPayloadInvoiceLine } from "routes/revenue_opportunity/form/invoiceLines";

const toInteger = value => {
  const parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? null : parsed;
};

/**
 * Form values as the create and update request body.
 *
 * `attachments` holds only the files uploaded during this session, because the
 * API attaches what it receives and removals go through their own endpoint.
 */
export const toRevenueOpportunityPayload = (
  values,
  { customFieldConfigs, attachments = [] }
) => ({
  entity_id: values.entity_id,
  campaign_id: values.campaign_id,
  case_ids: values.case_ids,
  contact_id: values.contact_id,
  status_id: values.status_id,
  value: getInvoicesTotalValue(values.invoices),
  recipient_type: values.recipient_type || null,
  recipient_id: values.recipient_id,
  billing_to: values.billing_to,
  purchase_order: values.purchase_order,
  invoice: values.invoice,
  invoice_date: values.invoice_date || null,
  sales_order: values.sales_order,
  sales_order_date: values.sales_order_date || null,
  comments: values.comments,
  invoices: values.invoices.map(toPayloadInvoiceLine),
  effective_date: values.effective_date,
  launch_date: values.launch_date || null,
  actionable_machines: toInteger(values.actionable_machines),
  attachments,
  assignee_id: values.assignee_id,
  region_id: values.region_id,
  country: values.country,
  tags: values.tags,
  points_of_contact: values.points_of_contact,
  custom_fields: customFieldsPayload(customFieldConfigs, values.custom_fields),
});

/** Ids of the saved attachments the user removed from the form. */
export const removedAttachmentIds = (record, values) => {
  const kept = new Set(values.attachments.map(attachment => attachment.id));
  return (record?.attachments ?? [])
    .map(attachment => attachment.id)
    .filter(id => !kept.has(id));
};
